import { render, staticRenderFns } from "./purchaseRequest.vue?vue&type=template&id=0cff01ae&scoped=true&"
import script from "./purchaseRequest.vue?vue&type=script&lang=js&"
export * from "./purchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRequest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./purchaseRequest.vue?vue&type=style&index=1&id=0cff01ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff01ae",
  null
  
)

export default component.exports